import HeroImageCard from '../cards/HeroImageCard'
import BackgroundImageCard from '../cards/BackgroundImageCard'
import IconImageCard from '../cards/IconImageCard'
import { generateDataHash } from '../../helpers/contentHash'

const FeaturedListCuratedCard = ({ props, cardItems, variant = 'background', textAlignment, isMember = null, onLockedClick }) => {
  const firstFeaturedItem = cardItems[0]
  const remainingItems = cardItems.slice(1)

  return (
    <div className="w-full px-4 md:px-6 lg:px-8 py-12 max-w-[1440px] mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-6 lg:gap-8">
        {/* left 40% */}
        <div className="md:col-span-2 flex flex-col justify-start">
          {variant === 'background' ? (
            <BackgroundImageCard {...props} cardItem={firstFeaturedItem} i={'0'} textAlignment={textAlignment} isMember={isMember} onLockedClick={onLockedClick} />
          ) : variant === 'hero' ? (
            <HeroImageCard cardItem={firstFeaturedItem} i={'0'} isMember={isMember} onLockedClick={onLockedClick} />
          ) : (
            <IconImageCard cardItem={firstFeaturedItem} i={'0'} isMember={isMember} onLockedClick={onLockedClick} />
          )}
        </div>

        {/* right 60% */}
        <div className="md:col-span-3 md:p-8 md:rounded-2xl flex flex-col justify-start text-white">
          {remainingItems.length > 0 &&
            remainingItems.map((item, idx) => (
              <HeroImageCard key={generateDataHash(item)} cardItem={item} i={idx + 1} isList={true} isMember={isMember} onLockedClick={onLockedClick} />
            ))}
        </div>
      </div>
    </div>
  )
}

export default FeaturedListCuratedCard
